import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { RenaultAnimationActionDetailDTO, RenaultAnimationActionDetailSupervisorDTO, RenaultAnimationActionDTO, RenaultAnimationActionGoalMatrixDTO, RenaultAnimationActionGoalMatrixGlobalDTO, RenaultAnimationActionRemuneration, RenaultAnimationActionResultFilterDTO } from '../models/renault-animation-action-dto';
import { Select2Data } from 'ng-select2-component';
import { RenaultAnimationActionExcelUserModel } from '../models/renault-animation-action-excel-user-model';

@Injectable({
  providedIn: 'root'
})

export class AnimationActionService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultAnimationAction/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<RenaultAnimationActionDTO> {
    return this.http.get<RenaultAnimationActionDTO>(this.pathAPI + this.controller + id);
  }

  public getUserAvailableAnimationAction(): Observable<RenaultAnimationActionDTO[]> {
    return this.http.get<RenaultAnimationActionDTO[]>(this.pathAPI + this.controller + "GetUserAvailableAnimationAction");
  }

  public getUserHistoricAnimationAction(year: number): Observable<RenaultAnimationActionDTO[]> {
    return this.http.get<RenaultAnimationActionDTO[]>(this.pathAPI + this.controller + "GetUserHistoricAnimationAction/" + year);
  }

  public getUserHistoricAnimationActionYears(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetUserHistoricAnimationActionYears');
  }

  public getUserAvailableAnimationActionRenaultZone(): Observable<RenaultAnimationActionDTO[]> {
    return this.http.get<RenaultAnimationActionDTO[]>(this.pathAPI + this.controller + "GetUserAvailableAnimationActionRenaultZone");
  }

  public getUserHistoricAnimationActionRenaultZone(year: number): Observable<RenaultAnimationActionDTO[]> {
    return this.http.get<RenaultAnimationActionDTO[]>(this.pathAPI + this.controller + "GetUserHistoricAnimationActionRenaultZone/" + year);
  }

  public getUserHistoricAnimationActionYearsRenaultZone(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetUserHistoricAnimationActionYearsRenaultZone');
  }

  public getUserAvailableAnimationActionMyZone(): Observable<RenaultAnimationActionDTO[]> {
    return this.http.get<RenaultAnimationActionDTO[]>(this.pathAPI + this.controller + "GetUserAvailableAnimationActionMyZone");
  }

  public getUserHistoricAnimationActionMyZone(year: number): Observable<RenaultAnimationActionDTO[]> {
    return this.http.get<RenaultAnimationActionDTO[]>(this.pathAPI + this.controller + "GetUserHistoricAnimationActionMyZone/" + year);
  }

  public getUserHistoricAnimationActionYearsMyZone(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetUserHistoricAnimationActionYearsMyZone');
  }

  public getAnimationActionDetail(id: string): Observable<RenaultAnimationActionDetailDTO> {
    return this.http.get<RenaultAnimationActionDetailDTO>(this.pathAPI + this.controller + "GetAnimationActionDetail/" + id);
  }

  public getAnimationActionDetailSupervisor(id: string): Observable<RenaultAnimationActionDetailSupervisorDTO> {
    return this.http.get<RenaultAnimationActionDetailSupervisorDTO>(this.pathAPI + this.controller + "GetAnimationActionDetailSupervisor/" + id);
  }

  public getAnimationActionResult(filters: RenaultAnimationActionResultFilterDTO): Observable<RenaultAnimationActionDetailSupervisorDTO[]> {
    return this.http.post<RenaultAnimationActionDetailSupervisorDTO[]>(this.pathAPI + this.controller + "GetAnimationActionResult", filters);
  }

  public approveAnimationActionLegal(id: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "ApproveAnimationActionLegal/" + id);
  }

  public post(data: RenaultAnimationActionDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: RenaultAnimationActionDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  }

  public getDataTableMyZone(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableMyZone', data);
  }

  public getAnimationActionGoalMatrix(id: string): Observable<RenaultAnimationActionGoalMatrixDTO> {
    return this.http.get<RenaultAnimationActionGoalMatrixDTO>(this.pathAPI + this.controller + "GetAnimationActionGoalMatrix/" + id);
  }

  public getAnimationActionGoalMatrixMyZone(id: string, idPvgroup: number): Observable<RenaultAnimationActionGoalMatrixDTO> {
    return this.http.get<RenaultAnimationActionGoalMatrixDTO>(this.pathAPI + this.controller + "GetAnimationActionGoalMatrixMyZone/" + id + "/" + idPvgroup);
  }

  public getAnimationActionGoalMatrixRenaultZone(id: string): Observable<RenaultAnimationActionGoalMatrixGlobalDTO> {
    return this.http.get<RenaultAnimationActionGoalMatrixGlobalDTO>(this.pathAPI + this.controller + "GetAnimationActionGoalMatrixRenaultZone/" + id);
  }

  getAnimationActionExcel(idAction: string[]): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetAnimationActionExcel';
    return this.http.post<Blob>(endpoint, idAction, requestOptions);
  }

  getAnimationActionUserExcel(): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetAnimationActionUserExcel';
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  public getRenaultAnimationActionRemuneration(idAction: string): Observable<RenaultAnimationActionRemuneration> {
    return this.http.get<RenaultAnimationActionRemuneration>(this.pathAPI + this.controller + "GetRenaultAnimationActionRemuneration/" + idAction);
  }

  public animationIsInHistory(idAction: string): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'AnimationIsInHistory/' + idAction);
  }

  public reloadAnimationActionHistory(id: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "ReloadAnimationActionHistory/" + id);
  }

  public getDatatableBbddUsers(): Observable<RenaultAnimationActionExcelUserModel[]> {
    return this.http.get<RenaultAnimationActionExcelUserModel[]>(this.pathAPI + this.controller + "GetDatatableBbddUsers");
  }
}
